import ABSService from "./absService";
import requestHelper from "../utils/requestHelper";

class CuaKhauService extends ABSService {
    constructor() {
        super("cuakhau");
    }
}

export default CuaKhauService;